import { render } from "./Person.vue?vue&type=template&id=61a6ba80"
import script from "./Person.vue?vue&type=script&lang=js"
export * from "./Person.vue?vue&type=script&lang=js"
script.render = render

export default script